/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
//import {Link, browserHistory} from 'react-router';
import {browserHistory} from 'react-router';
import {bindActionCreators} from 'redux';
import CaseDataTable from '../caseDataTable/CaseDataTable';
import * as caseDataAction from '../../../actions/caseDataActions';
import * as accountActions from '../../../actions/accountActions';
import * as pathConsts from '../../../constants/pathConstants';
import Button from '../../common/Button';
import CaseDataDashboardHeading from './CaseDataDashboardHeading';
import '../../../styles/establishment/establishmentHeader.css';
import '../../../styles/caseData/caseDataDashboard.css';
import CaseDataFilterRow from './CaseDataFilterRow';
import ConfirmActionModal from '../../common/ConfirmActionModal';
import {createApiPath} from '../../../api/fetch/fetchServices';
import {ITAAlert} from '../../common/ITAAlert';
import * as apiConstants from '../../../constants/apiConstants';
import * as injurySummaryActions from '../../../actions/injurySummaryActions';
import ManualRefreshDetection from '../../common/ManualRefreshDetection';

class CaseDatasDashboardPage extends React.Component {

  constructor(props, context) {
    super(props, context);
    let newFilterValues = Object.assign({}, this.props.filterValues);
    this.state = {
      caseDatas: props.caseDatas,
      pageSize: props.pageSize ? props.pageSize : 10,
      message: null,
      currentPage: 1,
      filingYear: new Date().getFullYear() - 1,
      establishmentId: parseInt(this.props.params.establishmentId),
      filterValues: this.props.filterValues,
      newFilterValues,
      filteredCaseData: Object.assign({}, this.props.filteredCaseData),
      filtersSetPreviously: this.props.filtersSetPreviously,
      modalShown: false,
      currentCase: null,
      injurySummaries: props.injurySummaries,
      establishments: props.establishments
    };
    // console.log("Debugging construction");
    // console.log("Props in constructor");
    // console.log(this.props);
    // console.log("State in constructor");
    // console.log(this.state);

    this.hideSubmitPage = this.hideSubmitPage.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.redirect = this.redirect.bind(this);
    this.handleCreateCaseDataClick = this.handleCreateCaseDataClick.bind(this);
    this.changePageSize = this.changePageSize .bind(this);
    this.redirectToEditEstablishment = this.redirectToEditEstablishment.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.showConfirmDelete = this.showConfirmDelete.bind(this);
    this.onConfirmDelete = this.onConfirmDelete.bind(this);

    // Filter
    this.enteringDataFilter = this.enteringDataFilter.bind(this);
    this.onSelectFilter = this.onSelectFilter.bind(this);
    this.filteredCaseData = this.filteredCaseData.bind(this);
    this.setFilters = this.setFilters.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
  }

  componentDidMount() {
    this.loadDataForEstablishment(this.props.params.establishmentId);
  }

  componentWillReceiveProps(nextProps) {
    //set a success message if case data is is created/edited
    let message = '';
    if (nextProps.successMsg === "CaseData" && !this.state.message) {
      message = nextProps.newCase
        ? <div className="first-line">
          300And301 data has been submitted.
        </div>

        : <div className="first-line">
          300And301 data has been updated.
        </div>;
      this.setState({ message: message });
    }
    // Set the case datas to re-loaded props. CaseDatas in props
    // will change when load all case datas action completes.
    // There is a bug with this. If you delete all items then
    // the list will reset to the full list from props.
    // @todo - remove this and use render from props and use reducer.
    this.setState({
      caseDatas: nextProps.caseDatas
    });
    this.setState({
      injurySummaries: nextProps.injurySummaries
    });
  }

  componentDidUpdate(prevProps) {
    const currentEstablishmentId = this.props.params.establishmentId;
    const prevEstablishmentId = prevProps.params.establishmentId;
    // Check if the URL parameter (establishmentId) has changed
    if (currentEstablishmentId !== prevEstablishmentId) {
      this.loadDataForEstablishment(currentEstablishmentId);
    }
  }

  toggleModal() {
    // console.log('toggleModal called.');
    this.setState({
      modalShown: !this.state.modalShown
    });
  }

  // A helper function to load data for establishment id.
  loadDataForEstablishment(establishmentId) {
    this.props.caseDataAction.loadAllCaseData(parseInt(establishmentId));
    this.props.injSumActions.loadAllInjurySummaryData(parseInt(establishmentId));
  }

  showConfirmDelete(caseData) {
    // console.log('showConfirmDelete called.');
    this.setState({
      modalShown: true,
      currentCase: caseData,
      message: null
    });
  }

  onConfirmDelete() {
    // console.log('onConfirmDelete called.');
    const caseData = this.state.currentCase;
    // Don't do anything if caseId is null.
    if (caseData === null) {
      return;
    }
    const caseId = caseData.id;
    const deletePath = createApiPath(apiConstants.deleteCaseDataApi, caseId);
    fetch(deletePath, {
      method: 'DELETE',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      },
      // Don't have to call createCaseDataObject since the format is
      // what is expected in the API call.
      body: JSON.stringify(caseData),
    })
    .then((response) => response.json())
    .then((responseJson) => {
      console.log(responseJson);
      const estabToUpdate = this.props.establishments.find((estab) => estab.id == this.props.params.establishmentId);
      this.props.caseDataAction.updateEstablishmentStatus(Object.assign({}, estabToUpdate, {total_submitted_cases: estabToUpdate.total_submitted_cases - 1}));
      if (responseJson.success) {
        const newCaseDatas = this.state.caseDatas.filter((item) => item.id !== caseId);
        // Update global case data state.
        this.props.caseDataAction.loadAllCaseData(parseInt(this.props.params.establishmentId));
        // console.log('newCaseDatas in onConfirmDelete');
        // console.log(newCaseDatas);
        this.setState({
          caseDatas: newCaseDatas,
          modalShown: false,
          currentCase: null,
          message: this.getAlertMessage("Successfully deleted the item (id:" + caseId + ").", "success")
        });
      }
      else {
        this.setState({
          modalShown: false,
          currentCase: null,
          message: this.getAlertMessage("There was an error deleting the item (id:" + caseId + ").", "danger")
        });
      }
      // console.log('State in onConfirmDelete');
      // console.log(this.state);
    })
    .catch((error) => {
      console.error('Error deleting data:', error);
      this.setState({
        modalShown: false
      });
    });
  }

  getAlertMessage(message, type) {
    return (
      <ITAAlert
        style={type}
        message={<div className="first-line">{message}</div>} />
    );
  }

  hideSubmitPage() {
    let submitValues = this.state.submitValues;
    submitValues['resubmissionReason'] = '';
    submitValues['agreementSubmit'] = '0';
    let isActive = true;
    this.setState({
      submitValues: submitValues,
      isActive: isActive,
      showModal: false
    });
  }

  handleClick(event) {
    let isActive = this.state.isActive;
    let submitValues = this.state.submitValues;
    if (submitValues['agreementSubmit'] === "1") {
      submitValues['agreementSubmit'] = "0";
      isActive = true;
    } else {
      submitValues['agreementSubmit'] = event.target.value;
      isActive = false;
    }
    this.setState({
      submitValues: submitValues,
      isActive: isActive
    });
  }

  /*
   **  Pager specific code.  When reusing the pager, make sure to add a
   **  state variable called "currentPage" with a starting value of 1.
   **
   */
  getPage(caseDatas) {
    let start = this.state.pageSize * (this.state.currentPage - 1);
    let end = start + this.state.pageSize;
    let numPages = this.getNumPages(caseDatas);
    let caseDatasNum = caseDatas.length;
    caseDatas = caseDatas.slice(start, end);
    let length = caseDatas.length;
    let currentCaseDatasNum;
    if (length == 1) {
        currentCaseDatasNum = (start + 1);
    } else {
        currentCaseDatasNum = (start + 1) + " - " + (start + length);
    }

    return {
      currentPage: this.state.currentPage,
      currentCaseDatasNum,
      caseDatas,
      caseDatasNum,
      numPages,
      handlePagerClick: function (pageNum) {
        return function () {
          this.handlePageChange(pageNum);
        }.bind(this);
      }.bind(this)
    };
  }

  getNumPages(caseDatas) {
    let numPages = Math.floor(caseDatas.length / this.state.pageSize);
    if (caseDatas.length % this.state.pageSize > 0) {
      numPages++;
    }
    return numPages;
  }

  handlePageChange(pageNum) {
    this.setState({currentPage: pageNum});
  }

  redirect(path) {
    browserHistory.push(path);
  }

  redirectToEditEstablishment(event) {
    event.preventDefault();
    let path =
    `${pathConsts.pathToEstablishmentsDashboardPage}/`
    + this.state.establishmentId;
    this.redirect(path);
  }

  handleCreateCaseDataClick(event) {
    event.preventDefault();
    let path =
      `${pathConsts.pathToEstablishmentsDashboardPage}/`
      + this.state.establishmentId
      + event.target.name;
    this.redirect(path);
  }

  changePageSize(event) {
    event.preventDefault();
    this.setState({
      pageSize: parseInt(event.target.value)
    });
    this.setState({currentPage: 1});
  }

  pager(page) {
    return (
      <div className="pager">
        {/* Include the ManualRefreshDetection component */}
        <ManualRefreshDetection />
        <div className="establishment-number col-sm-4 col-xs-6 text-left-md">
          Results {page.currentCaseDatasNum} of {page.caseDatasNum}
        </div>
        <div className="page-size-selector col-sm-4 col-xs-6 text-right-md pull-right">
          <select className="" onChange={this.changePageSize}>
            <option value={20}>Show 20 per page</option>
            <option value={50}>Show 50 per page</option>
            <option value={100}>Show 100 per page</option>
            <option value={250}>Show 250 per page</option>
          </select>

        </div>
        <div className="pager-buttons col-sm-4 col-xs-12">
          <button
            className={"pageLink first " + ((page.currentPage <= 2) ? "disabled" : "")}
            onClick={page.handlePagerClick(1)}
            disabled={page.currentPage <= 2}>«
          </button>
          <button
            className={"pageLink previous " + ((page.currentPage == 1) ? "disabled" : "")}
            onClick={page.handlePagerClick(page.currentPage - 1)}
            disabled={page.currentPage == 1}>‹
          </button>
          <span className="currentPage">Page {page.currentPage} of {page.numPages}</span>
          <button
            className={"pageLink next " + ((page.currentPage > (page.numPages - 1))
            ? "disabled" : "")}
            onClick={page.handlePagerClick(page.currentPage + 1)}
            disabled={page.currentPage > (page.numPages - 1)}>›
          </button>
          <button
            className={"pageLink last " + ((page.currentPage >= (page.numPages - 1))
            ? "disabled" : "")}
            onClick={page.handlePagerClick(page.numPages)}
            disabled={page.currentPage >= (page.numPages - 1)}>»
          </button>
        </div>

      </div>
    );
  }

  /*
   **  End pager code
   */

  /**
   *
   * Filter Functionality
   */

  enteringDataFilter(event) {
    event.preventDefault();
    const field = event.target.name;
    let newFilterValues = this.state.newFilterValues;
    newFilterValues[field] = event.target.value;
    this.setState({newFilterValues: newFilterValues});
  }

  onSelectFilter(event) {
    event.preventDefault();
    const field = event.target.name;
    let newFilterValues = this.state.newFilterValues;
    newFilterValues[field] = event.target.value;
    this.setState({newFilterValues: newFilterValues});
  }

  setFilters(event) {
    event.preventDefault();
    let filtersSetPreviously = this.state.filtersSetPreviously;
    let filterValues;
    let newFilterValues = this.state.newFilterValues;
    if (filtersSetPreviously === true) {
      this.props.actions.clearCaseDataPageFilter();
      this.setState({
        filteredCaseData: [{}],
        filtersSetPreviously: false
      });
    }
    filterValues = Object.assign({}, newFilterValues);
    this.setState({
      filterValues: filterValues,
      currentPage: 1
    });

  }

  filteredCaseData(caseDatas = this.state.caseDatas) {
    // console.log('CaseData in filteredCaseData');
    // console.log(caseDatas);
    let filterValues = this.state.filterValues;
    // Filter by
    // case_number,
    // case_classification => Most Serious outcome
    // injury_illness_type
    if (filterValues.case_number !== '') {
      caseDatas = caseDatas.filter((caseData) => {
        return (caseData.case_number.toUpperCase().indexOf(filterValues.case_number.toUpperCase()) != -1);
      });
    }

    if (filterValues.case_classification !== '') {
      caseDatas = caseDatas.filter((caseData) => {
        return (caseData.case_classification == filterValues.case_classification);
      });
    }

    if (filterValues.injury_illness_type !== '') {
      caseDatas = caseDatas.filter((caseData) => {
        return (caseData.injury_illness_type == filterValues.injury_illness_type);
      });
    }
    // console.log('CaseData after filteredCaseData');
    // console.log(caseDatas);
    return caseDatas;
  }

  clearFilters() {
    let filterValues = this.state.filterValues;
    filterValues.case_number = '';
    filterValues.case_classification = '';
    filterValues.injury_illness_type = '';

    let caseDatas = this.state.caseDatas;

    if (this.state.filtersSetPreviously === true) {
      this.props.actions.clearCaseDataPageFilter();
      this.setState({
        filteredCaseData: [{}],
        fitlersSetPreviously: false
      });
    }
    this.setState({
      caseDatas: caseDatas,
      filterValues: filterValues,
      newFilterValues: Object.assign({}, filterValues)
    });
  }

  getCaseDataFilingProgress(caseDatas, injurySummaries) {
    const currentYear = new Date().getFullYear();
    const yearToFilter = currentYear - 1;

    let progressPercentage = 0;
    let expectedCases = 0;
    const totalCasesSoFar = caseDatas.length;
    if (injurySummaries) {
      const matchingSummary = injurySummaries.filter((summary) => summary.year_filing_for === yearToFilter)[0];
      if (matchingSummary) {
        expectedCases =
          matchingSummary.total_other_cases +
          matchingSummary.total_deaths +
          matchingSummary.total_dafw_cases +
          matchingSummary.total_djtr_cases;
        progressPercentage = (totalCasesSoFar / expectedCases) * 100;
      }
    }
    return [progressPercentage, expectedCases, totalCasesSoFar];
  }

  render() {
    let page;
    // console.log('State in render');
    // console.log(this.state);
    const targetEstablishment = this.state.establishments.find((establishment) => establishment.id === this.state.establishmentId);
    const establishmentName = targetEstablishment ? targetEstablishment.establishment_name : '';
    let progressPercentage, expectedCases, totalCasesSoFar;
    [progressPercentage, expectedCases, totalCasesSoFar] = this.getCaseDataFilingProgress(this.state.caseDatas, this.state.injurySummaries);
    if (this.state.filteredCaseData.length !== 0 &&
      typeof this.state.filteredCaseData.length !== 'undefined'
      && this.state.filtersSetPreviously === true) {
      page = this.getPage(this.state.filteredCaseData);
      // console.log('First if');
    }
    else if (this.state.filteredCaseData.length === 0
      && this.state.filtersSetPreviously === true) {
      page = this.getPage(this.state.filteredCaseData);
      // console.log('Second if');
    }
    // Load the page from state if state exists. This will allow you to
    // delete items and delete items will vanish from state. However
    // this is not the right approach. This should be done via reducer
    // and the rerender from props.
    // @todo - load from props and use reducer to delete.
    else if (this.state.caseDatas.length !== 0) {
      page = this.getPage(this.filteredCaseData(this.state.caseDatas));
      // console.log('Third if');
    }
    else {
      page = this.getPage(this.filteredCaseData(this.props.caseDatas));
      // console.log('Fourth if');
      // console.log('Props in render');
      // console.log(this.props);
    }
    return (
      <div id="case-data-dashboard-page">
        <h2>
            {establishmentName &&
              <div className="establishment-name">
                Establishment Name: <b className='case-data-dashboard-establishment-name'>{establishmentName}</b>
              </div>
            }
        </h2>
        <div>{this.state.message}</div>
        <CaseDataDashboardHeading/>
        <div className="case-data-buttons-container non-mobile row">
          <Button
            onClick={this.handleCreateCaseDataClick}
            name={pathConsts.pathToCaseDataFormPageAdd}
            value="Add 300/301 Data"
            disabled={false}
            className={"btn btn-primary col-md-3 col-sm-4 col-xs-12 pull-left create-case-btn"}
            id="create-case-btn"
            title="Add New 300/301 Data"/>
        </div>
        <div className="anchor-holder">
          <CaseDataFilterRow
            enteringData={this.enteringDataFilter}
            onSelect={this.onSelectFilter}
            setFilters={this.setFilters}
            clearFilters={this.clearFilters}
            newFilterValues={this.state.newFilterValues}/>
          <div className="submit-mobile-anchor" ref="submitMobileAnchor"/>
        </div>
        <div className="progress">
            <div className='progress-bar-outer'>{totalCasesSoFar} out of {expectedCases} cases submitted</div>
            <div className='progress-bar-inner' title={`${totalCasesSoFar} out of ${expectedCases} cases submitted`} role="progressbar" data-toggle="tooltip" style={{width: `${progressPercentage}%`}}>{totalCasesSoFar} out of {expectedCases} cases submitted</div>
          {/*<div
            className="progress-bar"
            role="progressbar"
            data-toggle="tooltip"
            style={{
              width: `${progressPercentage}%`,
              minWidth: '13%', // Setting minimum width to 10 to display text.
            }}
            title={`${totalCasesSoFar} out of ${expectedCases} cases submitted`}
          >
        </div>*/}
      </div>
        <CaseDataTable
          caseDatas={page.caseDatas}
          establishment_id={this.props.params.establishmentId}
          onSelect={this.clickSelectCaseData}
          onDelete={this.showConfirmDelete} />
        {page.caseDatas.length !== 0 && this.pager(page)}
        <div className="case-data-buttons-container non-mobile row">
          <Button
            onClick={this.redirectToEditEstablishment}
            value="Back to Establishment"
            className="btn col-md-3 col-sm-4 col-xs-12 pull-left case-data-button continue-to-submission-btn" />
        </div>
        <ConfirmActionModal
          modalShown={this.state.modalShown}
          onHide={this.toggleModal}
          onConfirm={this.onConfirmDelete}
          confirmTitle="Confirm delete"
          confirmText="Please confirm that you want to delete this item"
          confirmButtonText="Yes"
          cancelButtonText="No" />
      </div>
    );
  }
}

CaseDatasDashboardPage.propTypes = {
  caseDataAction: PropTypes.object.isRequired,
  accountActions: PropTypes.object.isRequired,
  caseDatas: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  pageSize: PropTypes.number.isRequired,
  filterValues: PropTypes.object.isRequired,
  filtersSetPreviously: PropTypes.bool.isRequired,
  filteredCaseData: PropTypes.array.isRequired,
  injurySummaries: PropTypes.object.isRequired,
  injSumActions: PropTypes.object.isRequired,
  establishments: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  // console.log('In mapState - Case Data');
  // console.log(state);
  let caseDatas = state.caseDatas,
  filteredCaseData = [],
  filterValues = {
    case_number: '',
    case_classification: '',
    injury_illness_type: ''
  };
  // let injurySummaries = state.injurySummaries;
  // console.log('Summary instate is ');
  // console.log(injurySummaries);
  // Do we need to hoold on state?
  let filtersSetPreviously = false;
  return {
    caseDatas: caseDatas,
    user: state.user[state.user.length - 1] || {},
    pageSize: 20,
    filterValues: filterValues,
    filtersSetPreviously: filtersSetPreviously,
    filteredCaseData: filteredCaseData,
    injurySummaries: state.injurySummaries,
    establishments: state.establishments
  };
}

function mapDispatchToProps(dispatch) {
  return {
    caseDataAction: bindActionCreators(caseDataAction, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch),
    injSumActions: bindActionCreators(injurySummaryActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseDatasDashboardPage);



/** WEBPACK FOOTER **
 ** ./src/components/caseData/CaseDataManagement/CaseDatasDashboardPage.js
 **/